/**
 * Rillion Prime API v1.0
 * A REST API endpoint for System operations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HeadersOnly } from './headersOnly';
import { RowStates } from './rowStates';

export interface BaseModel {
  headersOnly?: HeadersOnly;
  forProcessing?: boolean | null;
  index?: number | null;
  inspected?: boolean | null;
  locked?: boolean | null;
  lockedRowID?: number | null;
  lockedRowLockedTime?: string | null;
  lockedRowLoginName?: string | null;
  lockedRowRole?: string | null;
  lockID?: number | null;
  lockType?: number | null;
  parent?: BaseModel;
  rowState?: RowStates;
  selected?: boolean | null;
  keyValuesRowState?: RowStates;
}
